/**
 * Vitals Instagram Feed initializes before the section has layout width,
 * leaving a 0px grid on the storefront. Re-trigger layout once the feed mounts.
 */
(function () {
  const REFLOW_EVENT = 'resize';

  function requestFeedReflow(feed) {
    if (!feed || feed.offsetWidth === 0) return;
    window.dispatchEvent(new Event(REFLOW_EVENT));
  }

  function observeFeed(feed) {
    let reflowScheduled = false;

    const scheduleReflow = () => {
      if (reflowScheduled) return;
      reflowScheduled = true;
      requestAnimationFrame(() => {
        reflowScheduled = false;
        requestFeedReflow(feed);
      });
    };

    const resizeObserver = new ResizeObserver(scheduleReflow);
    resizeObserver.observe(feed);

    const mutationObserver = new MutationObserver(() => {
      if (feed.querySelector('.Vtl-InstagramFeedLayout__PostList')) {
        scheduleReflow();
        setTimeout(() => requestFeedReflow(feed), 250);
        setTimeout(() => requestFeedReflow(feed), 1000);
      }
    });

    mutationObserver.observe(feed, { childList: true, subtree: true });
    scheduleReflow();
  }

  function init() {
    document.querySelectorAll('#vitals-instagram-feed').forEach(observeFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
